import {login} from "@/api/login";
import {getUserInfo} from "@/api/home";
import {message} from "ant-design-vue";

export default {
    namespaced: true,
    state: () => ({
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
        companyInfo: JSON.parse(localStorage.getItem('companyInfo') || '{}'),
        loginInfo: JSON.parse(localStorage.getItem('loginInfo') || '{}'),
    }),
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setCompanyInfo(state, companyInfo) {
            state.companyInfo = companyInfo;
        },
        setLoginInfo(state, loginInfo) {
            state.loginInfo = loginInfo;
        },
    },
    actions: {
        // 登录系统
        loginSystem({ commit }, data) {
            return new Promise((resolve, reject) => {
                login(data).then((res) => {
                    if (res.code === 0) {
                        message.error(res.msg);
                    } else if (res.code === 1) {
                        commit('setLoginInfo', res.data.userinfo);
                        localStorage.setItem('loginInfo', JSON.stringify(res.data.userinfo));
                        // 获取用户信息
                        getUserInfo({token:res.data.userinfo.token}).then((res) => {
                            commit("setUserInfo",res.data)
                            localStorage.setItem('userInfo', JSON.stringify(res.data));
                            message.success('登录成功!')
                            resolve(res.data.userinfo);
                        })
                    }
                }).catch((error) => {
                    message.error(error.msg);
                });
            });
        },
        // 退出系统
        logoutSystem({ commit }) {
            commit('setUserInfo', {});
            commit('setCompanyInfo', {});
            commit('setLoginInfo', {});
            localStorage.removeItem('userInfo');
            localStorage.removeItem('loginInfo');
            localStorage.removeItem('companyInfo');
        }
    },
    getters: {
        userInfo: (state) => state.userInfo,
        token: (state) => state.loginInfo.token,
        use_company_id: (state) => state.userInfo.use_company_id,
    }
};